<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Background Verification Checklist
        </div>
        <div class="card-body p-1">
            <form class="g-3" name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm"
                novalidate>
                <div class="row m-1">
                    <div class="col-md-5 px-1">
                        <label class="text-label-light">Vendor</label>
                        <ng-select name="Vendor" [items]="Vendors" bindLabel="APIName" bindValue="ESS_BGVApiMasterID"
                            [(ngModel)]="this.Filter.ess_bgvApiMasterId" (change)="Clear()"
                            placeholder="Select Vendor">
                        </ng-select>
                    </div>
                    <div class="col"></div>
                    <div class="col-auto pt-3">
                        <button class="btn btn-primary" name="submit">
                            <i class="bi bi-search" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Search':'Loading...'}}
                        </button>
                    </div>
                </div>
            </form>


            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Name</th>
                        <th style="width: 5px;">Days</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    [routerLink]="['/master/bgvchecklist/add/',TableData['ESS_BGVCheckListMasterID']]"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td>{{TableData['CheckListName']}}</td>
                        <td style="width:5px" class="text-end">{{TableData['InitiationDays']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>